import { createSelector } from "reselect"
import {
  getMemberCoverageType,
  getMemberHasHsa,
  getMemberHasLegalPartner,
  getPartnerCoverageType,
  getPartnerHasHsa,
  getPartnerPlanSource
} from "../reducers/userInfo"

/*
  Temporary fix to deal with data differences. A member's coverage type is in a bad state when the
  assumed values we set from the new memberCoverageType enrollment view are not as we expect.
  If there is a sync issue, we prompt the user to enter the information again.
 */
export const getMemberCoverageTypeWithDataFix = createSelector(
  [getMemberCoverageType, getMemberHasLegalPartner, getPartnerCoverageType, getPartnerPlanSource],
  (memberCoverageType, memberHasLegalPartner, partnerCoverageType, partnerPlanSource) => {
    const badDataState =
      memberCoverageType === "FAMILY" &&
      (memberHasLegalPartner !== true || partnerCoverageType !== "FAMILY" || partnerPlanSource !== "EMPLOYER")
    return badDataState ? null : memberCoverageType
  }
)

/*
  Temporary fix to deal with data differences. A member's hsa value is in a bad state
  if a member's coverage type is FAMILY and the partner does not have an HSA value.

  This code assumes that getMemberCoverageTypeWithDataFix will run before it, which at the
  time of writing this is always the case.
 */
export const getMemberHasHsaWithDataFix = createSelector(
  [getMemberCoverageType, getMemberHasHsa, getPartnerHasHsa],
  (memberCoverageType, memberHasHsa, partnerHasHsa) => {
    const badDataState = memberCoverageType === "FAMILY" && partnerHasHsa !== memberHasHsa
    return badDataState ? null : memberHasHsa
  }
)
